<div class="flex max-h-[90vh] w-[33vw] flex-col overflow-hidden bg-white">
  <div class="border-theme-gray-500 flex flex-row justify-between border-b p-6">
    <span class="block w-fit text-xl">{{ title }}</span>
    <button class="material-icons" [ngStyle]="{ color: '#575757' }" (click)="closeDialog.emit()">
      close
    </button>
  </div>
  <div class="overflow-y-scroll p-6">
    <ng-content></ng-content>
  </div>
  <div class="border-theme-gray-500 flex min-h-16 flex-row border-t text-xs">
    @if (closeText) {
      <button (click)="closeDialog.emit()" class="w-1/2 font-bold uppercase">
        {{ closeText }}
      </button>
    }
    <button
      (click)="acceptDialog.emit(); $event.stopPropagation()"
      (mouseup)="$event.stopPropagation()"
      (mousedown)="$event.stopPropagation()"
      class="bg-primary font-semibold text-white uppercase"
      [ngClass]="closeText === null ? 'w-full' : 'w-1/2'">
      {{ acceptText }}
    </button>
  </div>
</div>
